export { authActions } from "./actions";

export { AuthActionTypes } from "./actionTypes";
export { AuthMutationTypes } from "./mutationTypes";
export { AuthGetterTypes } from "./getters";

import { auth } from "./modules";
export default auth;
